"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var SplitTransform =
/** @class */
function (_super) {
  __extends(SplitTransform, _super);

  function SplitTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SplitTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var response = queryResponse;
    var splitSeparator = this.options.splitSeparator;

    if (queryResponse && splitSeparator) {
      response = queryResponse.toString();

      if (typeof response === 'string') {
        response = response.split(splitSeparator);
      }
    }

    return response;
  };

  return SplitTransform;
}(BaseTransform_1.BaseTransform);

exports.SplitTransform = SplitTransform;